import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import "./css/Navbar.css";
import logoPasaporte from "../img/pasaporte_empleo.png";

const NavbarRegistro = () => {
  const { isAuthenticated, role } = useSelector((state) => state.auth);

  return (
    <nav className="menu fixed fondo-blanco w-100 menu-registro">
      <div className="menu-wrapper-inner main-container-wrapper">
        <Link to="/">
          <img
            src={logoPasaporte}
            alt="Logo Pasaporte Hacia el Empleo"
            className="logo"
               width={100}
          height={200}
          fetchPriority="high"
          />
        </Link>
      </div>
    </nav>
  );
};

export default NavbarRegistro;
